import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { classes } from '../../utils/Classes';
import { Row, Column } from '@estee/elc-grid';
import { Heading2 } from '@estee/elc-typography';

interface ICategoryHeader {
    categoryTag: string;
}

export const StyledHeaderColumn = styled(Column)`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const productTagHeaderWrapper = classes('product-tag-header-wrapper');
const productTagHeaderClassnames = classes('product-tag-header');

export const CategoryHeader = observer(function CategoryHeader(props: ICategoryHeader) {
    return (
        <Row>
            <StyledHeaderColumn className={productTagHeaderWrapper}>
                <Heading2 className={productTagHeaderClassnames}>{props.categoryTag}</Heading2>
            </StyledHeaderColumn>
        </Row>
    );
});
